import React, { useEffect } from "react";
import loader from "../../../utils/assests/loaderp2p.png";
import { useHistory } from "react-router";
import InfoFormP2p from "../../../Common/InfoFormP2p";
import useTimer from "../../../Hook/useTimer";
import {useSelector } from "react-redux";

const InfoP2p = () => {
  const history = useHistory();
  const { seconds, setSeconds } = useTimer(5);
  const {ckycDetailsError} = useSelector(
    (state: any) => state.personalInfo
  );

  useEffect(() => {
    if (seconds === 0) {
      if (ckycDetailsError && ckycDetailsError.errors) {
        history.push("/p2p/ckycDetails");
      } else {
        history.push("/p2p/infoConfirmP2p");
      }
    }
  }, [seconds]);

  return (
    <>
      <InfoFormP2p
        imgShow={loader}
        title="you seem to be an existing user with <br/> Stashfin wait while we fetch your KYC <br/> documents"
      />
    </>
  );
};

export default InfoP2p;